// eslint-disable-next-line import/no-unresolved
import { getConfig } from '@edx/frontend-platform';

import messages from './messages';

export { default as logoHeader } from './logo.png';
export { default as footerLogo } from './logo-footer.png';
export { default as svgSprite } from './svg-sprite.svg';

export const footerIcons = [];

export const footerLinks = [
  {
    href: `${getConfig().LMS_BASE_URL}/contributor`,
    message: messages['footer.staticPages.contributor'],
    targetBlank: false,
  },
  {
    href: `${getConfig().LMS_BASE_URL}/privacy`,
    message: messages['footer.staticPages.privacy'],
    targetBlank: false,
  },
  {
    href: `${getConfig().LMS_BASE_URL}/tos`,
    message: messages['footer.staticPages.tos'],
    targetBlank: false,
  },
  {
    href: `${getConfig().LMS_BASE_URL}/support/contact_us`,
    message: messages['footer.staticPages.contact'],
    targetBlank: false,
  },
];

export const isFooterDark = true;

export const displayCreatedByBlock = true;
